export default "__VITE_ASSET__NtPXrVxY__"